module.exports = __webpack_public_path__ + "static/img/SRZ.8fcd4069.png";